import * as React from "react";

const OptionalStepsModal = ({ optionalSteps, closeOptionalStepsModal, onStepClick, numberOfNotOptionalSteps }) => {

  const modalRef = React.useRef(null);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeOptionalStepsModal();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeOptionalStepsModal]);

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50 px-2">
      <div
        ref={modalRef}
        className="bg-white rounded-xl shadow-lg p-6 w-full max-w-xl text-xs sm:text-base"
      >
        <h2 className="text-sm sm:text-xl font-semibold mb-4">Etapas Opcionais</h2>
        <ul className="list-decimal ml-5">
          {optionalSteps.map((step, index) => (
            <li
              key={step.stepName}
              className="cursor-pointer hover:underline"
              onClick={() => {
                closeOptionalStepsModal();
                onStepClick(index + numberOfNotOptionalSteps);
              }}
            >
              {step.stepName} ({step.completed
                ? <span className='text-green-600'>Preenchida</span>
                : <span className='text-red-600'>Não preenchida</span>})
            </li>
          ))}
        </ul>
        <div className="mt-6 flex justify-end">
          <button
            onClick={closeOptionalStepsModal}
            className="px-4 py-2 bg-emerald-600 text-white rounded hover:bg-emerald-700"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  )
}

export default OptionalStepsModal;